const isIdCard = (rule, value, callback) => {
  if (value && value.length != 18) {
    callback(new Error("号码应为18位数"));
  } else {
    callback();
  }
};
export function customerListConfig(getMoney, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    searchShow:false,
    index: true,
    indexLabel: "序号",
    refreshBtn: true,
    labelWidth: 120,
    selection: true,
    selectionWidth: 45,
    dialogWidth:'40%',
    column: [{
        label: "客户名称",
        placeholder: "请输入客户名称",
        search: true,
        slot: true,
        
        prop: "custNameT",
        overHidden: true,
        display: false
      }, {
        sortable: "custom",
        label: "客户编号",
        prop: "custNo",
        display: false,
        overHidden: true
      }, {
        label: "业务经理",
        prop: "businessManage",
        overHidden: true,
        search: true,
        display: false,
        click: () => {
          selectPersonClick("businessManage");
        }
      }, 
      {
        label: "客户类别",
        prop: "custCategory",
        type: "radio",
        search: true,
        dicData: [{
            label: "个人客户",
            value: 1,
          },
          {
            label: "机构客户",
            value: 2,
          },
        ],
        // dataType: 'number',
        // dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_category",
        // props: {
        //   label: "dictValue",
        //   value: "dictKey",
        // },
        value: 1,
        span: 24,
        hide: true,
        display:false,
        rules: [{
          required: true,
          message: "请选择客户类别",
          trigger: "blur",
        }, ],
      },{
        label: "客户类别",
        prop: "basicCustType",
        type: "radio",
        search: false,
        dicData: [{
            label: "个人客户",
            value: 1,
          },
          {
            label: "机构客户",
            value: 2,
          },
        ],
        // dataType: 'number',
        // dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_category",
        // props: {
        //   label: "dictValue",
        //   value: "dictKey",
        // },
        value: 1,
        span: 24,
        hide: true,
        rules: [{
          required: true,
          message: "请选择客户类别",
          trigger: "blur",
        }, ],
      }, {
        label: "客户名称",
        formslot: true,
        labelslot: true,
        prop: "custName",
        overHidden: true,
        span: 24,
        hide: true,
        fixed: true,
        display: true,
        hideshow: true,
        rules: [{
          required: true,
          message: "请输入客户名称",
          trigger: "blur",
        }, ],
      },

      {
        label: "统一社会信用代码",
        prop: "unifiedSocialCreditCode",
        display: true,
        labelslot: true,
        hideshow: true,
        disabled: true,
        hide: true,
        span: 24,
        slot: true,
        placeholder: '回显',
        rules: [{
          required: true,
          message: "请输入",
          trigger: "blur",
        }, ],
      },

      {
        label: "客户简称",
        prop: "custShortName",
        span: 24,
        hide: true,
        hideshow: true,
        rules: [{
          required: true,
          message: "请输入客户简称",
          trigger: "blur",
        }, ],
        display: true,
      }, {
        label: "客户性质",
        prop: "custAttribute",
        type: "select",
        search: true,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=bl_cust_attribute",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        // dicData: [{
        //     label: "买方",
        //     value: 1,
        //   },
        //   {
        //     label: "卖方",
        //     value: 2,
        //   }, {
        //     label: "其他",
        //     value: 3,
        //   }
        // ],
        hide: true,
        display: false,

      }, {
        label: "首次拜访时间",
        prop: "firstVisitTime",
        overHidden: true,
        search: false,
        type: "daterange",
        display: false,
      }, {
        label: "最新拜访时间",
        prop: "latestVisitTime",
        overHidden: true,
        search: false,
        type: "daterange",
        display: false,
      }

    ]
  }
}


export function filterConfig(selectPersonClick, selectDeptClick) {
  return {
    column: [{
        label: "搜索查询",
        placeholder: "项目名称",
        prop: "sellerCustName",
        overHidden: true,
      }, {
        label: "搜索查询",
        placeholder: "请输入客户名称",
        prop: "factoringCredit",

      }, {
        label: '业务类型',
        prop: "factoringType",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
      },
      {
        label: '保理商',
        prop: "factoringEntity",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=bl_accounting_entity',
        props: {
          label: "dictValue",
          value: "dictKey"
        },

      },
      {
        label: "业务经理",
        placeholder: "请选择业务经理",
        width: "120",
        prop: "managerUserName",
        click: () => {
          selectPersonClick();
        }
      }, {
        label: "所属部门",
        placeholder: "请选择部门",
        prop: "managerDeptName",
        width: "150",
        click: () => {
          selectDeptClick();
        }
      },
      {
        label: '立项状态',
        prop: "auditStatus",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_build_state',
        props: {
          label: "dictValue",
          value: "dictKey"
        },

      },
      {
        label: '审核状态',
        prop: "auditStatus",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        formatter: (row, value, label, column) => {
          return label ? label : "未提交";
        },
        dataType: "string",
        search: true,
        hide: true
      }
    ]
  }
}
export function transferConfig(selectPersonClick) {
  return {
    labelWidth: 140,
    emptyBtn: false,
    column: [

      {
        label: "已选择 2个 客户",
        labelslot: true,
        prop: "blCustNames",
        placeholder: "",
        readonly: true,
        labelWidth: 140,
        span: 24,
        rules: [{
          required: true,
          message: "请选择",
          trigger: "blur",
        }, ],

      },
      {
        label: '接受人',
        prop: 'receiveUser',
        span: 24,
        rules: [{
          required: true,
          message: '请输入接受人'
        }],
        click: () => {
          selectPersonClick("receiveUser");
        }
      },
      {
        label: "移交原因",
        prop: "reason",
        type: "textarea",
        minRows: 3,
        span: 24,
        rules: [{
          required: true,
          message: '请输入移交原因'
        }],
      },
    ]
  }
}


export function applyConfig() {
  return {
    menuType: "button",
    menuWidth: 380,
    menuAlign: "center",
    align: "center",
    card: false,
    tip: false,
    lazy: false,
    tree: false,
    filterable: false,
    editBtn: false,
    cellBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    searchBtn: false,
    columnBtn: false,
    refreshBtn: false,
    labelWidth: 200,
    dialogClickModal: false,
    index: true,
    indexLabel: "序号",
    menu: false,
    column: [{
        label: "客户名称",
        prop: "blCustNames",

        display: true,
      },
      {
        label: "移交人",
        prop: "userName",
        width:'100',
        display: true,
      },
      {
        label: "接受人",
        prop: "receiveUserName",
        width:'100'
      },
      {
        label: "移交原因",
        prop: "reason",
      },
      {
        label: "提交时间",
        prop: "createTime",
        width:'150'
      },
      {
        label: "审核状态",
        prop: "status",
        formatter: (row, value, label, column) => {
          return label == 0 ? '审核中' : label == 1 ? "通过" : '退回';
        },
        width:'100'
      },
      {
        label: "审核人",
        prop: "auditUserName",
        width:'100'
      },
      {
        label: "原因",
        prop: "auditRemark",
      },


    ]
  }
}
export function auditConfig() {
  return {
    menuType: "button",
    menuWidth: 380,
    menuAlign: "center",
    align: "center",
    card: false,
    tip: false,
    lazy: false,
    tree: false,
    filterable: false,
    editBtn: false,
    cellBtn: false,
    delBtn: false,
    addBtn: false,
    searchBtn: false,
    columnBtn: false,
    refreshBtn: false,
    labelWidth: 200,
    dialogClickModal: false,
    index: true,
    indexLabel: "序号",
    menu: false,
    selection: true,
    selectionWidth: 45,
    column: [{
        label: "客户名称",
        prop: "blCustNames",

        display: true,
      },
      {
        label: "移交人",
        prop: "userName",

        display: true,
      },
      {
        label: "接受人",
        prop: "receiveUserName",
      },
      {
        label: "移交原因",
        prop: "reason",
      },
      {
        label: "提交时间",
        prop: "createTime",
      },
    ]
  }
}
